/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import { selectVersion } from '../configuration/configuration.slice';
import { ResourceType } from '../../enums/ResourceType';
import { integrationApiPath } from '../../../settings';
import {
  selectAutocompleteOptions,
  selectCurrentOption,
  updateOptions,
  updateSelectedOption,
} from './autocomplete.slice';
import { getAutocompleteOptions, getSelectedOptionDetails, isSelectedOptionValid } from './autocomplete.thunk';
import { showAlertError } from '../alerts/alerts.slice';
import { createMessage } from '../alerts/alerts.helper';

export function useAutocomplete({ configuration }) {
  const { name } = configuration;

  const dispatch = useDispatch();
  const version = useSelector(selectVersion);
  const options = useSelector(state => selectAutocompleteOptions(state, name));
  const current = useSelector(state => selectCurrentOption(state, name));

  const buildIntegrationResourceUrl = () => {
    if (!configuration) return null;

    switch (configuration.type) {
      case ResourceType.COMMON:
        return `${integrationApiPath}/${configuration.path}`;
      default:
        break;
    }

    return configuration.path;
  };

  const url = buildIntegrationResourceUrl();
  const getOptions = async (category) => {
    try {
      return dispatch(getAutocompleteOptions({ url, category, name }));
    } catch (e) {
      dispatch(showAlertError(createMessage(i18next.t('error.page.generic.title'), e)));
      return [];
    }
  };
  const getSelectedOption = async (category, code) => {
    dispatch(getSelectedOptionDetails({ url, category, code, name }));
  };

  const resetAutocomplete = () => {
    dispatch(updateSelectedOption({ name, response: null }));
    dispatch(updateOptions({ name, response: [] }));
  };

  const validateOption = async (option) => {
    return dispatch(isSelectedOptionValid({ url, option }));
  };

  return {
    version,
    options,
    current,
    getOptions,
    getSelectedOption,
    buildIntegrationResourceUrl,
    resetAutocomplete,
    validateOption,
  };
}
